import { ActivityItemShell } from "../../shell/ActivityItemShell";
import { ActivityShellAction } from "../../shell/ActivityShellTypes";
import { ActivityPluginProps } from "../../registry/ActivityPluginTypes";
import { usePinActivityHook } from "../../../hooks/pinActivityHook";
import { deleteActivityAction } from "../../../ActivityHistory";
import { TranslationService } from "../../../../../../services/TranslationService";
import CompanyService from "../../../../../../services/CompanyService";
import FloatingPanelService from "../../../../../shared/FloatingPanel";
import TooltipComponent from "../../../../../shared/TooltipComponent";
import { LabelActionText } from "../../../components/NewComment";
import { SMSView } from "../../../../components/SMSView";
import {
  formatDateDigits,
  formatDateTimeDigits
} from "../../../../../../utils/FormatUtils";
import { restTimezone } from "../../../../../../utils/ParseUtils";
import { addIf } from "../../../../../../utils/Utils";
import iconSMS from "../../../../../../assets/img/iconSMS.svg";
import iconSMSError from "../../../../../../assets/img/iconSMSError.svg";

export const ActivitySmsCard = ({ data, reload }: ActivityPluginProps) => {
  const { translate } = TranslationService;
  const reloadSimple = () => reload();
  const { icon, canPin, togglePinActivity, tooltip } = usePinActivityHook({
    data,
    reload: reloadSimple
  });

  const openSms = () => {
    FloatingPanelService.showPanel({
      children: <SMSView data={data} />,
      title: "SMS",
      width: 600,
      height: 400
    });
  };

  const isFailed = data.Failed;
  const phoneNumber = data.smsphone ?? "";
  const date = new Date(data.date);

  const iconNode = (
    <TooltipComponent title={isFailed ? translate.SMSError : translate.SMSOk}>
      <img
        className="img-fluid"
        src={isFailed ? iconSMSError : iconSMS}
        alt="icon sms"
      />
    </TooltipComponent>
  );

  const headerNode = (
    <div className="type">
      {TranslationService.getTranslation(data.typeName)}
      <span className="creator">
        {" "}
        {translate.From.toLowerCase()}{" "}
        {phoneNumber.split(", ").reverse().join(" ")}
      </span>
    </div>
  );

  const contentNode = (
    <div>
      {data.Subject && (
        <small>
          <em>
            <strong>
              {translate.Subject}: {data.Subject}
            </strong>
          </em>
        </small>
      )}
      <div style={{ whiteSpace: "pre-line" }}>{data.Content}</div>
      {data.groupName && data.groupName.length > 0 && (
        <div style={{ marginRight: 10 }}>
          <strong>{CompanyService.getGroupName()}</strong>:{" "}
          <em>{data.groupName}</em>
        </div>
      )}
      {data.tagList && data.tagList.length > 0 && (
        <div className="d-flex align-items-center">
          <TooltipComponent title={translate.Tags}>
            <i className="fa fa-tag activity-icon-color my-2" />
          </TooltipComponent>
          <div className="d-flex align-items-center gap-2">
            {data.tagList.split(",").map((tag, i) => (
              <div key={i}>
                <LabelActionText bgColor={false} text={tag} action={() => {}} />
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );

  const dateNode = (
    <div className="dateTertiaryQ">
      {date.getHours() === 0 && date.getMinutes() === 0
        ? formatDateDigits(date)
        : formatDateTimeDigits(restTimezone(date))}
    </div>
  );

  const actions: ActivityShellAction[] = [
    ...addIf(canPin, { icon, onClick: togglePinActivity, tooltip }),
    { icon: "fa-search", onClick: openSms }
  ];

  if (
    CompanyService.canDo("deletecomment") &&
    (CompanyService.getIsAdmin() ||
      (data.Creator ?? 0) === parseInt(CompanyService.getUserid()))
  ) {
    actions.push(
      deleteActivityAction(
        data.ID,
        translate.SMSDeleteTitle,
        translate.SMSDeleteMessage,
        reloadSimple
      )
    );
  }

  const compactLine = (
    <>
      <strong>{phoneNumber}</strong>
      {" - "}
      {data.Content ?? ""}
    </>
  );

  return (
    <ActivityItemShell
      cardClassName="historyCard"
      iconNode={iconNode}
      headerNode={headerNode}
      dateNode={dateNode}
      content={contentNode}
      actions={actions}
      compactLine={compactLine}
    />
  );
};
